import PriceDisplay from '@/components/PriceDisplay';
import { TransText } from '@/i18n/trans/text';
import { Icons, Typography } from '@fleet/webshop-ui';
import type { FC } from 'react';

interface RefundTotalProps {
  refundTotal: number;
}

const RefundTotal: FC<RefundTotalProps> = ({ refundTotal }) => {
  return (
    <div className="flex items-start justify-between border-t border-t-primary px-4 py-3">
      <div className="flex gap-2">
        <Icons.buyReturnTicket className="h-4 w-4 text-primary" />
        <Typography variant="body2-bold">
          <TransText i18nKey="totalRefund" />
        </Typography>
      </div>
      <Typography variant="body2-bold" className="flex text-success-text">
        {'-'}
        <PriceDisplay amount={refundTotal} />
      </Typography>
    </div>
  );
};

export default RefundTotal;
